import PageContainer from '@components/PageContainer';
import AuthFormLayout from '@layouts/form/AuthFormLayout';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useSession from '@hooks/useSession';
import { refreshAccessToken } from '../../utils/authSession';

function MicrosoftCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setIsAuthenticated } = useSession();
  const [error, setError] = useState(null);

  useEffect(() => {
    const run = async () => {
      const errorCode = searchParams.get('error');
      if (errorCode) {
        setError(errorCode);
        return;
      }
      if (searchParams.get('success') !== '1') {
        setError('invalid_callback');
        return;
      }
      const token = await refreshAccessToken();
      if (!token) {
        setError('session_failed');
        return;
      }
      setIsAuthenticated(true);
      navigate('/', { replace: true });
    };
    run();
  }, [navigate, searchParams, setIsAuthenticated]);

  return (
    <PageContainer title="Qualz.ai | Signing in">
      <AuthFormLayout title="Signing you in" text="Completing Microsoft sign-in…">
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
          {error ? (
            <Typography color="error" align="center">
              Microsoft sign-in failed ({error}).{' '}
              <Typography
                component="span"
                sx={{ cursor: 'pointer', color: 'primary.main' }}
                onClick={() => navigate('/signin')}
              >
                Back to sign in
              </Typography>
            </Typography>
          ) : (
            <CircularProgress />
          )}
        </Box>
      </AuthFormLayout>
    </PageContainer>
  );
}

export default MicrosoftCallback;
